import { Typography } from 'antd';
import { FC, memo } from 'react';

import { useTranslate } from 'hooks';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';

import s from './index.module.scss';

export const SaleProjectNote: FC<{ validUntil: string }> = memo(({ validUntil }) => {
	const { pleaseNoteText, saleOfferValidText, saleNoteText } = useTranslate([
		'pleaseNoteText',
		'saleOfferValidText',
		'saleNoteText',
	]);

	return (
		<div className={s.note}>
			<span className={s.noteText}>
				<InfoIcon />
				{pleaseNoteText}
			</span>
			<div>
				<Typography.Text type="secondary">{saleOfferValidText}:&nbsp;</Typography.Text>
				<span>{validUntil}</span>
			</div>
			<Typography.Text>{saleNoteText}</Typography.Text>
		</div>
	);
});
